import {
  SecondaryNavIdentifier,
  TertiaryNavIdentifier,
} from '@zola-helpers/client/dist/es/constants/navConstants';
import { ResponsiveDesignProvider } from '@zola/zola-ui/src/contexts/ResponsiveDesignContext/ResponsiveDesignProvider';

import cx from 'classnames';
import { Provider } from 'react-redux';

import ClientApp from '~/ClientApp';
import ClientRouter from '~/ClientRouter';
import MainLayout from '~/components/common/layouts/MainLayout/MainLayout';
import { UserContextProvider } from '~/contexts/UserContext';
import { ExpertAdviceForSRP } from '~/pages/couples/explore/components/ExpertAdvice/ExpertAdviceForSrp';
import { PageSection } from '~/pages/couples/explore/components/PageSection/PageSection';
import { AdjacentVendors } from '~/pages/couples/explore/components/SearchResults/components/AdjacentVendors/AdjacentVendors';
import { RealWeddings } from '~/pages/couples/explore/components/SearchResults/components/RealWeddings/RealWeddings';
import { SearchResultsPageBreadcrumbs } from '~/pages/couples/explore/components/SearchResults/components/SearchBreadcrumb/SearchBreadcrumb';
import { SearchResultsHead } from '~/pages/couples/explore/components/SearchResults/components/SearchResultsHead/SearchResultsHead';
import { SeoContentBlock } from '~/pages/couples/explore/components/SearchResults/components/SeoContentBlock/SeoContentBlock';
import { SearchResultsPageProvider } from '~/pages/couples/explore/components/SearchResults/contexts/SearchResultsPageProvider';
import { VendorSearchNavigationProvider } from '~/pages/couples/explore/components/SearchResults/contexts/VendorSearchNavigationProvider';
import { SearchResultsContent } from '~/pages/couples/explore/components/SearchResults/SearchResultsContent';
import SearchResultsPageModalsAndToasts from '~/pages/couples/explore/SearchResultsPageModalsAndToasts';
import { getStore } from '~/store';

import { SRPSearchBarProvider } from './components/SearchControls/SRPSearchBarContext';
import { TopPicksSection } from './components/TopPicks/TopPicksSection';
import { SearchResultsPageProps } from './types/props';

import styles from './searchResultsPageLayout.module.less';

export const ControlPage = ({
  identifiedAsVendor,
  navHtml,
  parsedUrl,
  userAgent,
  userContext,
  ...rest
}: SearchResultsPageProps) => {
  return (
    <UserContextProvider userContext={userContext}>
      <ResponsiveDesignProvider userAgent={userAgent} useV2>
        <Provider store={getStore()}>
          <MainLayout
            activeSecondaryLink={SecondaryNavIdentifier.EXPLORE_VENDORS}
            activeTertiaryLink={
              parsedUrl.vendorSearch.selectedTaxonomy?.key as TertiaryNavIdentifier
            }
            ssrNavHtml={navHtml}
            className={cx(styles.mainLayout)}
          >
            <SearchResultsPageProvider
              {...rest}
              identifiedAsVendor={identifiedAsVendor}
              parsedUrl={parsedUrl}
            >
              <VendorSearchNavigationProvider>
                <SearchResultsHead />

                <TopPicksSection />
                <SearchResultsPageBreadcrumbs location="top" />

                <SRPSearchBarProvider>
                  <SearchResultsContent />
                </SRPSearchBarProvider>
                <AdjacentVendors />
                <ExpertAdviceForSRP />

                <RealWeddings />
                <PageSection>
                  <SeoContentBlock />
                </PageSection>
                <SearchResultsPageBreadcrumbs location="bottom" />
              </VendorSearchNavigationProvider>

              <ClientApp useStore={false}>
                <ClientRouter>
                  <SearchResultsPageModalsAndToasts />
                </ClientRouter>
              </ClientApp>
            </SearchResultsPageProvider>
          </MainLayout>
        </Provider>
      </ResponsiveDesignProvider>
    </UserContextProvider>
  );
};
